import type { RequirementsDocumentOutput, WerkcurveOutput, PhaseId, PhaseQuality, PhaseStatus } from '@/lib/interview/types';

export interface PhaseQualitySnapshot {
  phase_id: PhaseId;
  quality: PhaseQuality | null;
  status: PhaseStatus;
}

export interface OutputData {
  requirements?: RequirementsDocumentOutput;
  werkcurve?: WerkcurveOutput;
  phaseQuality?: PhaseQualitySnapshot[];
}

export type TabType = 'overview' | 'werkcurve' | 'use_cases' | 'plan' | 'requirements';

const phaseLabels: Record<PhaseId, string> = {
  discovery: 'Kennismaking',
  deep_dive: 'Verdieping',
  summary: 'Afsluiting',
};

const qualityLabels: Record<string, string> = {
  rich: 'Rijk',
  adequate: 'Voldoende',
  shallow: 'Beperkt',
};

const qualityBadge: Record<string, string> = {
  rich: 'bg-teal/20 text-teal-dark',
  adequate: 'bg-teal/10 text-teal',
  shallow: 'bg-orange-cta/15 text-orange-hover',
};

export function translatePhase(id: PhaseId): string {
  return phaseLabels[id] || id;
}

export function translatePhaseQuality(q: PhaseQuality | null | undefined): string {
  if (!q) return 'Onbekend';
  return qualityLabels[q] || q;
}

export function getPhaseQualityBadge(q: PhaseQuality | null | undefined): string {
  if (!q) return 'bg-off-black/10 text-off-black/60';
  return qualityBadge[q] || 'bg-off-black/10 text-off-black/60';
}

export function getPriorityColor(priority: string): string {
  switch (priority) {
    case 'high':
      return 'bg-red-500/15 text-red-600';
    case 'medium':
      return 'bg-orange-cta/15 text-orange-cta';
    default:
      return 'bg-off-black/10 text-off-black/60';
  }
}

export function getStanceColor(stance: string): string {
  switch (stance) {
    case 'champion':
      return 'bg-teal/20 text-teal-dark';
    case 'supporter':
      return 'bg-teal/15 text-teal';
    case 'neutral':
      return 'bg-off-black/10 text-off-black/60';
    default:
      return 'bg-red-500/15 text-red-600';
  }
}


// ============================================================================
// Dutch Translations for Enum Values
// ============================================================================

const priorityLabels: Record<string, string> = {
  high: 'Hoog',
  medium: 'Midden',
  low: 'Laag',
};

export function translatePriority(priority: string): string {
  return priorityLabels[priority] || priority;
}

const stanceLabels: Record<string, string> = {
  champion: 'Voorvechter',
  supporter: 'Voorstander',
  neutral: 'Neutraal',
  skeptic: 'Sceptisch',
};

export function translateStance(stance: string): string {
  return stanceLabels[stance] || stance;
}

const influenceLabels: Record<string, string> = {
  high: 'Hoge',
  medium: 'Gemiddelde',
  low: 'Lage',
};

export function translateInfluence(influence: string): string {
  return influenceLabels[influence] || influence;
}

